// Opções de obrigações pagas exibidas no cadastro e no perfil do associado.
// Os valores são gravados como texto em members.obrigacoes_pagas — renomear
// uma opção deixa os cadastros antigos com o valor anterior.

// Abian ainda não passou pela feitura: no cadastro, data de feitura e idade
// de santo deixam de ser obrigatórias. O backend usa o mesmo texto
// (MemberRegisterRequest::ABIAN).
export const OBRIGACAO_ABIAN = 'Abian';

export const OBRIGACOES_OPTIONS = [
  OBRIGACAO_ABIAN,
  'Borí',
  'Feitura',
  'Obrigação de 1 ano',
  'Obrigação de 3 anos',
  'Obrigação de 5 anos',
  'Obrigação de 7 anos',
  'Obrigação de 14 anos',
  'Obrigação de 21 anos',
];
